import { render, staticRenderFns } from "./LabelHeaderEditPage.vue?vue&type=template&id=54549fbc&scoped=true&"
import script from "./LabelHeaderEditPage.vue?vue&type=script&lang=ts&"
export * from "./LabelHeaderEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./LabelHeaderEditPage.vue?vue&type=style&index=0&id=54549fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54549fbc",
  null
  
)

export default component.exports